import { LogoWrapper, LogoImage, LogoName } from "./styles";

export const NEXONIC_LOGO_SRC = "/img/nexonic-logo.png";

interface NexonicLogoProps {
  size?: number;
  showName?: boolean;
  nameSize?: "sm" | "md" | "lg";
  gap?: number;
  inline?: boolean;
  name?: string;
  className?: string;
  variant?: "light" | "dark";
}

const NexonicLogo = ({
  size = 44,
  showName = false,
  nameSize = "md",
  gap = 10,
  inline = true,
  name = "Nexonic Etch",
  className,
  variant = "dark",
}: NexonicLogoProps) => {
  return (
    <LogoWrapper $gap={gap} $inline={inline} className={className}>
      <LogoImage
        src={NEXONIC_LOGO_SRC}
        alt="Nexonic Etch logo"
        $size={size}
        $rounded={Math.round(size * 0.18)}
      />
      {showName && (
        <LogoName $size={nameSize} $variant={variant}>
          {name}
        </LogoName>
      )}
    </LogoWrapper>
  );
};

export default NexonicLogo;
